import { useEffect, useRef, useState } from "react";
// import AudioPlayer from "./Audioplayer";
import LoginForm from "./LoginForm";
import { firestore } from "../firebase-config";
import { collection, getDocs } from "firebase/firestore";


const Home = () => {    
    
    const [bizToplam, setBizToplam] = useState(0);
    const [sizToplam, setSizToplam] = useState(0);
    
    useEffect(() => {
      const fetchAndSumFields = async () => {
        const querySnapshot = await getDocs(collection(firestore, "2025")); // Koleksiyon adını kullan
        let totalBiz = 0;
        let totalSiz = 0;
        
        querySnapshot.forEach((doc) => {
          const data = doc.data();
          totalBiz += Number(data.biz) || 0; // String’i sayıya çevir ve hata olursa 0 kabul et
          totalSiz += Number(data.siz) || 0;
        });
  
        // State'leri güncelliyoruz
        setBizToplam(totalBiz);
        setSizToplam(totalSiz);
      };
  
      fetchAndSumFields();
    }, []);
    
    
    return ( 
<> <div className="min-h-screen flex items-center justify-center " 
    // style={{ backgroundImage: "url('/images/arkablanresim2.jpg')", 
    // backgroundSize: 'cover', backgroundPosition: 'center', }} 
    >   

    <div className=" p-8 rounded-lg shadow-lg max-w-sm w-full"> 
        {/* Biz Toplam ve Siz Toplam kısmı */}
        <div className="flex justify-between text-6xl font-extrabold text-scoreColor" 
                    style={{ fontFamily: 'Scoreboard', backgroundColor: 'black', padding: '5px', borderRadius: '10px' }}>
                    <div >
                    <span className="ml-5 block">Biz </span>
                    <span className="flex justify-center items-center pl-5">{bizToplam}</span>
                    </div>
                    <div>
                    <span className="mr-5 block">Siz </span>
                    <span className="flex justify-center items-center pr-5">{sizToplam}</span>
                    </div>
        </div>


    {/* <h1 className="text-3xl font-bold text-center mb-6">Hoşgeldiniz!</h1>  */}
    {/* <p className="text-gray-600 text-center mb-8">Lütfen Gmail hesabınız ile giriş yapınız.</p>  */}
    <div className="flex justify-center mt-6"> 
        
<LoginForm /> </div> </div> </div> </> ); };

export default Home;
